import { useLayoutEffect, useRef } from "react";

// Makes a list/table scroll internally (sticky header) by sizing the scroll
// container to the space actually available below it in the viewport.
// Robust against tall page headers where a fixed `100vh - Xrem` overshoots.
export function useStickyTableScroll(gap = 24) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const wrapper = ref.current;
    if (!wrapper) return;
    const target = wrapper.firstElementChild || wrapper;
    const apply = () => {
      const top = target.getBoundingClientRect().top + window.scrollY;
      const h = window.innerHeight - top - gap;
      target.style.maxHeight = `${Math.max(h, 200)}px`;
      target.style.overflow = "auto";
    };
    apply();
    window.addEventListener("resize", apply);
    const ro = new ResizeObserver(apply);
    ro.observe(document.body);
    return () => {
      window.removeEventListener("resize", apply);
      ro.disconnect();
    };
  }, [gap]);
  return ref;
}
